export const isIterable = (obj?: unknown) => {
  try {
    if (!obj) return false;
    return Symbol.iterator in new Object(obj);
  } catch (error) {
    console.error(error);
    return false;
  }
};
